import { discussions, hotTags } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Discussion() {
  return (
    <section id="discussion" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <SectionHeading
          kicker="Discussion"
          title="读者讨论：大家都在聊什么"
          desc="这里汇总读者社区中讨论度较高的话题与标签，帮助你快速了解作品被反复解读的地方，也能顺藤摸瓜找到同类同人创作。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {hotTags.map((tag) => (
            <span
              key={tag.name}
              className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-background-50 border border-background-200 text-sm text-foreground-700 whitespace-nowrap"
            >
              <i className="ri-hashtag text-secondary-600" />
              {tag.name}
              <span className="text-xs text-foreground-400">{tag.count}</span>
            </span>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-5">
          {discussions.map((thread) => (
            <article
              key={thread.title}
              className="p-5 rounded-lg bg-background-50 border border-background-200 flex flex-col"
            >
              <div className="flex items-center justify-between gap-3">
                <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs whitespace-nowrap">
                  {thread.tag}
                </span>
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
                  <i className="ri-chat-3-line" />
                  {thread.replies} 条回复
                </span>
              </div>
              <h3 className="mt-3 font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug">
                {thread.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{thread.excerpt}</p>
              <div className="mt-4 pt-3 border-t border-background-200 text-xs text-foreground-500">
                发起人 · {thread.author}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}